import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Header, {
  getFirstFlg,
  getFixedFlg,
  getInitTenpoCode,
  setFirstFlg,
  setReadFixedFlg,
} from "../../Header/Header";
import TSCheckTab from "./TSCheckTab";
import { Redirect } from "react-router-dom";
import { isFirebaseAuth } from "../../../firebase";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import {
  getJobCategoryFromCode,
  isOpenRegistPage,
} from "../../../apis/privilege";
import { postRequest } from "../../../apis/axiosAction";
import {
  checkAuthUser,
  checkOperationCount,
  eventListeners,
  DAY_TIMER_SECOND,
  HOUR_TIMER_SECOND,
  HOUR_TIMER_MILL_SECOND,
} from "../../../apis/util";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerRoot: {
      flexGrow: 1,
    },
    header: {
      flexGrow: 1,
    },
    headerToolbar: {
      // ヘッダーの縦の調整はminHeight を再設定する
      [theme.breakpoints.down("sm")]: {
        minHeight: "36px",
      },
      [theme.breakpoints.up("md")]: {
        minHeight: "48px",
      },
    },
    root: {
      height: "100vh",
    },
    gridMargin: {
      padding: "1%",
    },
  })
);

// 対象店舗衛生点検ID
let initTSCheckId: string = "";
let initLastTSCheckId: string = "";
/** データセット */
export function setTSCheckId(id: any) {
  initTSCheckId = id;
}
export function getTSCheckId() {
  return initTSCheckId;
}
/** データセット */
export function setLastTSCheckId(id: any) {
  initLastTSCheckId = id;
}
export function getLastTSCheckId() {
  return initLastTSCheckId;
}

const Home: React.FC = (props: any) => {
  const classes = useStyles();

  const [tenpoCode, setTenpoCode] = React.useState(getInitTenpoCode());
  const [tsCheckId, setTSCheckId] = React.useState("");
  const [lastTSCheckId, setLastTSCheckId] = React.useState("");
  const tenpoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setTenpoCode(event.target.value as string);
    setTSCheckId("");
    setLastTSCheckId("");
  };
  const [updateFlg, setUpdateFlg] = React.useState("");
  const user = useSelector(selectUser);
  const [count, setCount] = React.useState(DAY_TIMER_SECOND);
  const [click, setClick] = React.useState(false);
  const [click2, setClick2] = React.useState(false);

  useEffect(() => {
    let userInfo = user;
    checkAuthUser(userInfo);
    // 画面操作時にタイマーをリセットするイベントを設定
    eventListeners.forEach((event) => {
      document.addEventListener(event, () => {
        setCount(DAY_TIMER_SECOND);
      });
    });
  }, []);

  // 1時間ごとに操作の有無をチェックし、24時間操作がなければログアウトする
  useEffect(() => {
    if (!checkOperationCount(count)) {
      return;
    }
    const interval = setInterval(() => {
      setCount(count - HOUR_TIMER_SECOND);
    }, HOUR_TIMER_MILL_SECOND);
    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    if (tenpoCode === "" || getFirstFlg()) {
      setFirstFlg(false);
      setTenpoCode("");
      setTSCheckId("");
      setLastTSCheckId("");
      return;
    }
    if (initTSCheckId === "") {
      // 次回のデータを作成
      const apiParams = {
        tenpoCode: tenpoCode,
        jobCategory: getJobCategoryFromCode(user),
      };
      if (!getFixedFlg()) {
        setReadFixedFlg(true);
        setClick(!click);
      }
      const url = process.env.REACT_APP_API_URL_J11SPB22 + "tscheck/check-info-phase2";
      postRequest(url, apiParams)
        .then(async (res: any) => {
          setTSCheckId(res.data.dataList[0]);
          setLastTSCheckId(res.data.dataList[1]);
        })
        .finally(() => {
          setReadFixedFlg(false);
          setClick2(!click2);
        });
    } else {
      setTSCheckId(initTSCheckId);
      setLastTSCheckId(initLastTSCheckId);
    }
    setFirstFlg(false);
  }, [tenpoCode, updateFlg, getFirstFlg()]);

  // 画面表示可否
  if (!isFirebaseAuth()) {
    return <></>;
  }
  if (
    (!isOpenRegistPage(user) && !getFixedFlg()) ||
    (tenpoCode === "" && getFixedFlg())
  ) {
    return <Redirect to="/home" />;
  }

  return (
    <Grid container className={classes.root} justify="center">
      <Grid item xs={12}>
        <Header
          titleName={"店舗衛生点検表"}
          tenpoChange={(e) => tenpoChange(e)}
        />
        <Grid item xs={12} className={classes.gridMargin}>
          {tenpoCode === "" ? (
            <Grid container justify="center">
              右上の店舗名より新規作成する店舗を選択してください。
            </Grid>
          ) : (
            <TSCheckTab
              tenpoCode={tenpoCode}
              tsCheckId={tsCheckId}
              lastTSCheckId={lastTSCheckId}
              setUpdateFlg={setUpdateFlg}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Home;
